import { render, staticRenderFns } from "./templateEdit.vue?vue&type=template&id=19261891&"
import script from "./templateEdit.vue?vue&type=script&lang=js&"
export * from "./templateEdit.vue?vue&type=script&lang=js&"
import style0 from "./templateEdit.vue?vue&type=style&index=0&id=19261891&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports